import { isSameRootDomain } from './domain'

const SSO_URL = import.meta.env.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com'
const SSO_LOGIN_URL = `${SSO_URL}/auth/login`

/**
 * Tạo URL redirect sang SSO login.
 *
 * - Cùng root domain (*.hocnhe.com): SSO set cookie .hocnhe.com, app đọc luôn.
 *   → redirect_url = trang hiện tại (hoặc origin)
 *
 * - Khác domain (localhost, domain khác): Cookie không share.
 *   → redirect_url = /auth/callback, SSO kèm ?code=xxx, app exchange lấy token.
 */
export function getSSOLoginUrl(returnTo?: string): string {
  const sameDomain = isSameRootDomain(window.location.href, SSO_URL)

  // 1. Ưu tiên đọc mã giới thiệu từ URL hiện tại
  const urlParams = new URLSearchParams(window.location.search)
  let ref = urlParams.get('ref')

  // 2. Nếu không có, đọc tiếp từ cookie dự phòng
  if (!ref) {
    const match = document.cookie.match(/(?:^|; )referrer_code=([^;]*)/)
    ref = match ? decodeURIComponent(match[1]) : null
  }

  let targetUrl = ''
  if (sameDomain) {
    targetUrl = returnTo || window.location.href
  } else {
    targetUrl = `${window.location.origin}/auth/callback`
  }

  let ssoUrl = `${SSO_LOGIN_URL}?redirect_url=${encodeURIComponent(targetUrl)}`
  if (ref) {
    ssoUrl += `&ref=${encodeURIComponent(ref)}`
  }
  return ssoUrl
}

export function redirectToSSOLogin(returnTo?: string): void {
  window.location.href = getSSOLoginUrl(returnTo)
}

export { SSO_URL }
